<template>
  <Modal 
    :custom-icon-close="'close_rounded.svg'"
    @close="closeModalBanner"
    @clickOutside="closeModalBanner"
  >
    <div class="modal-banner">
      <img
        :src="getImg"
        alt="banner.svg"
        @click="clickModalBanner"
      >
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/new-modal/Modal.vue";
import mixinMobile from "@/misc/mixinMobile.js";
import { setBannerPopup } from "@/misc/Cookies.js";

export default {
  name: "ModalBanner",
  components: {
    Modal,
  },
  mixins: [mixinMobile],
  computed: {
    getImg() {
      return this.windowWidth <= 599
        ? 'https://storage.googleapis.com/lionparcel-web-stg/asset/popup_mobile.webp'
        : 'https://storage.googleapis.com/lionparcel-web-stg/asset/popup_codongkir.webp';
    },
  },
  methods: {
    clickModalBanner() {
      setBannerPopup();
      this.$router.push('/dropoff-order');
    },
    closeModalBanner() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/style";

::v-deep .modal-lp__content {
  border-radius: 24px;
}

::v-deep .modal-lp__content__close {
  display: flex;
  top: 8px;
  right: 8px;
}

::v-deep .modal-lp__content__body {
  padding: 0;
}

.modal-banner {
  display: flex;
  flex-direction: row;
  cursor: pointer;

  img {
    border-radius: 24px;
  }
}
</style>
